'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkedDefaultProps = exports.checkedPropTypes = exports.useChecked = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useChecked = exports.useChecked = function useChecked(props) {
  var checked = props.checked,
      defaultChecked = props.defaultChecked,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(defaultChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checkedState = _useState2[0],
      setCheckedState = _useState2[1];

  var handleChange = (0, _react.useCallback)(function (evt) {
    setCheckedState(evt.target.checked);
    if (onChange) onChange(evt);
  }, [onChange]);

  return {
    checked: checked !== undefined ? checked : checkedState,
    onChange: handleChange
  };
};

var checkedPropTypes = exports.checkedPropTypes = {
  checked: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};

var checkedDefaultProps = exports.checkedDefaultProps = {
  defaultChecked: false
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/hooks/useChecked.js
// module id = 210
// module chunks = 177